import { useEffect, useRef } from "react";

import type { RealtimeEventType, RealtimeHandler } from "./RealtimeHandler";
import { registerRealtimeHandler } from "./registerRealtimeHandler";

// Обработчик события, пока смонтирован компонент. Обработчик можно передавать
// замыканием: перерегистрации на каждый рендер нет, вызывается последняя версия.
export const useRealtimeHandler = <T extends RealtimeEventType>(
  type: T,
  handler: RealtimeHandler<T>,
): void => {
  const handlerRef = useRef(handler);
  useEffect(() => {
    handlerRef.current = handler;
  });
  useEffect(
    () =>
      registerRealtimeHandler(type, (event, context) => {
        handlerRef.current(event, context);
      }),
    [type],
  );
};
